































import { Vue, Component, Prop, PropSync } from "vue-property-decorator";

@Component({ components: {} })
export default class MiniModal extends Vue {
  @PropSync("isActive", { default: false }) active!: boolean;
  @Prop({ default: -17 }) top!: number;
  @Prop({ default: 23 }) right!: number;
  data() {
    return {};
  }
}
